precision mediump float;

uniform vec3 uColor;
uniform float uOpacity;

varying vec2 vUv;
varying float vElevation;

void main() {
    vec3 color = uColor;
    
    // 根据高度变化（褶皱和风吹的起伏）计算阴影和高光
    // vElevation 大约在 -0.5 到 0.5 之间
    
    // 模拟光照：凸起的地方更亮，凹陷的地方更暗
    float shadow = smoothstep(-0.2, 0.2, vElevation);
    
    // 混合基础颜色和阴影/高光
    // 凹陷处变暗 (0.6倍)，凸起处变亮 (1.2倍)
    float lightIntensity = mix(0.6, 1.2, shadow);
    color *= lightIntensity;
    
    // 添加一点环境光遮蔽 (AO) 效果，顶部固定处更暗一点
    float ao = mix(0.8, 1.0, 1.0 - vUv.y);
    color *= ao;

    gl_FragColor = vec4(color, uOpacity);
}